module.exports = __webpack_public_path__ + "d607b3c21222fab95a99d7ad055a671e.jpg";